import React, { useEffect, useState } from "react";
import {
  ChevronDown,
  ChevronRight,
  Workflow,
  CheckCircle2,
  Summary,
  PackageSearch
} from "lucide-react";
import { ThirdWBSAPI } from "../services/api";

import { useNavigate } from "react-router-dom";

interface TreeNode {
  text: string;
  tag: number;
  color?: string;
  children?: TreeNode[];
  wbsNo?: number;
  front?: number;
}

interface Props {
  projectId: number;
   projectName: string;
    activityLevel: number;
  onActivityClick: (activityId: number, wbsId: number) => void;
  onWbsClick: (wbsId: number) => void;
}

const getNodeKey = (node: TreeNode) => {
  if (node.tag === 0) return "root";

  return `wbs-${node.tag}`;
};

const AccordionNode = ({
  node,
  level = 0,
  projectId,
   projectName,
  activityLevel,
  selectedItem,
  setSelectedItem,
  openNodes,
  setOpenNodes,
  onActivityClick,
  onWbsClick,
}
: {
  node: TreeNode;
  level?: number;
  projectId: number;
  projectName: string;
  activityLevel: number;

    selectedItem: {
    type: "wbs" | "activity";
    id: number;
  } | null;

  setSelectedItem: React.Dispatch<
    React.SetStateAction<{
      type: "wbs" | "activity";
      id: number;
    } | null>
  >;

  openNodes: Record<string, boolean>;

setOpenNodes: React.Dispatch<
  React.SetStateAction<Record<string, boolean>>
>;

  onActivityClick: (activityId: number, wbsId: number) => void;
  onWbsClick: (wbsId: number) => void;
}) => {
  //const [open, setOpen] = useState(level === 0);
  const nodeKey = getNodeKey(node);

  const navigate = useNavigate();

const open = openNodes[nodeKey] ?? (level === 0);



  const [activities, setActivities] = useState<TreeNode[]>([]);
  const [loaded, setLoaded] = useState(false);

  const hasChildren = !!(node.children && node.children.length > 0);

  const shouldShowActivities =
    activityLevel === 0 ? level === 0 : level === activityLevel;

  const canLoadActivities = shouldShowActivities && (node.tag > 0 || level === 0);

  const loadActivities = async (lvl: number) => {
    if (!canLoadActivities) return;

    try {
      const res = await ThirdWBSAPI.getActivities(projectId, node.tag, lvl);

      const activityNodes: TreeNode[] = res.map((a: any) => ({
        text: a.text,
        tag: a.tag,
        children: [],
      }));

      setActivities(activityNodes);
      setLoaded(true);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setActivities([]);
    setLoaded(false);

    if (open && shouldShowActivities) {
      loadActivities(activityLevel);
    }
   
  }, [activityLevel, open, shouldShowActivities]);

  const handleToggle = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (!open && !loaded && shouldShowActivities) {
      await loadActivities(activityLevel);
    }

    //setOpen((prev) => !prev);
    setOpenNodes((prev) => {
  const updated = {
    ...prev,
    [nodeKey]: !prev[nodeKey],
  };

  sessionStorage.setItem(
    "ThirdWBSOpenNodes",
    JSON.stringify(updated)                 
  );

  return updated;
});
  };

  return (
    <div>
      <div
        //className="flex cursor-pointer items-center rounded-md px-2 py-1 hover:bg-indigo-50"
       // className={`flex cursor-pointer items-center rounded-md px-2 py-1
         className={`group flex cursor-pointer items-center rounded-md px-2 py-1
${
 // selectedItem?.type === "wbs" &&
 // selectedItem.id === node.tag
 (selectedItem?.type === "wbs" &&
 selectedItem.id === node.tag) ||
(node.tag === 0 && selectedItem === null)
    ? 
    //"bg-blue-100 border border-blue-300"
    "bg-indigo-50"
    : "hover:bg-indigo-50"
}`}
        style={{ paddingLeft: `${level * 10}px` }}
       //style={{ paddingLeft: `${level * 4}px` }}
       
       
       /* onClick={() => {
          if (node.tag > 0) {
            onWbsClick(node.tag);
          }
        }} */
       onClick={() => {
  if (node.tag > 0) {
   /*  setSelectedItem({
      type: "wbs",
      id: node.tag,
    });
 */
const item = {
  type: "wbs" as const,
  id: node.tag,
};

setSelectedItem(item);

sessionStorage.setItem(
  "ThirdWBSSelectedItem",
  JSON.stringify(item)
);
    onWbsClick(node.tag);
  }
}}
      >
        {hasChildren || canLoadActivities ? (
          <button
            onClick={handleToggle}
            className="mr-1 flex h-4 w-4 items-center justify-center"
            type="button"
            aria-label={open ? "Collapse" : "Expand"}
            title={open ? "Collapse" : "Expand"}
          >
            {open ? (
              <ChevronDown size={14} strokeWidth={2} className="text-gray-600" />
            ) : (
              <ChevronRight size={14} strokeWidth={2} className="text-gray-600" />
            )}
          </button>
        ) : (
          <span className="mr-1 w-4 opacity-0">+</span>
        )}

       {/*  <Workflow
          size={16}
          className={
            node.tag > 0 ? "mr-2 text-indigo-500" : "mr-2 text-green-600"
          }
        />
 */}
        {/* <div className="flex items-center gap-2 min-w-0">
          <span
            className={
              node.tag > 0 ? " text-gray-800" : " text-green-700"
            }
          >
            {node.text}
          </span>

        </div> */}
        <div className="flex items-center gap-2 min-w-0">
  <span
    className={
      node.tag > 0 ? "text-gray-800" : "text-green-700"
    }
  >
    {node.text}
  </span>

 {/*  {node.tag > 0 && (
    <button
      onClick={(e) => {
        e.stopPropagation();
        window.open(`/boq/${node.tag}`, "_blank");
      }}
      className="p-1 rounded hover:bg-gray-200
                 opacity-0 pointer-events-none
                 group-hover:opacity-100
                 group-hover:pointer-events-auto
                 transition-all duration-200"
      title="BOQ"
    >
      <Summary size={14} color="black" />
    </button>
  )}
 */}
 {node.tag > 0 && (
  <>
    {/* BOQ Button */}
    <button
      onClick={(e) => {
        e.stopPropagation();

        window.open(
          `/boq/${node.tag}`,
          "_blank",
          "noopener,noreferrer"
        );
      }}
      className="p-1 rounded hover:bg-gray-200
                 opacity-0 pointer-events-none
                 group-hover:opacity-100
                 group-hover:pointer-events-auto
                 transition-all duration-200"
      title="BOQ"
    >
      <Summary size={14} color="black" />
    </button>

    {/* WBS BOM Button */}
    <button
      onClick={(e) => {
        e.stopPropagation();

        const params = new URLSearchParams({
          projectId: String(projectId),
          projectName: projectName || "",
          wbsId: String(node.tag),
          wbsName: node.text || "",
        });

        window.open(
          `/wbs-bom?${params.toString()}`,
          "_blank",
          "noopener,noreferrer"
        );
      }}
      className="p-1 rounded hover:bg-gray-200
                 opacity-0 pointer-events-none
                 group-hover:opacity-100
                 group-hover:pointer-events-auto
                 transition-all duration-200"
      title="BOM"
    >
      <PackageSearch size={14} color="black" />
    </button>
  </>
)}

</div>


      </div>

      {open && (
        <div>
        {/*   {level < activityLevel &&
            node.children?.map((child, index) => (
              <AccordionNode
                key={`${child.tag}-${index}`}
                node={child}
                level={level + 1}
                projectId={projectId}
                projectName={projectName}
                activityLevel={activityLevel}
                 selectedItem={selectedItem}
  setSelectedItem={setSelectedItem}
  openNodes={openNodes}
setOpenNodes={setOpenNodes}
                onActivityClick={onActivityClick}
                onWbsClick={onWbsClick}
              />
            ))} */}
            {level < activityLevel &&
  [...(node.children || [])]
    .sort((a, b) => {
      const textA = String(a.text || "").trim();
      const textB = String(b.text || "").trim();

      // Extract leading number, if available
      const numberA = textA.match(/^\d+/);
      const numberB = textB.match(/^\d+/);

      // Numbered WBS items should come first
      if (numberA && numberB) {
        return Number(numberA[0]) - Number(numberB[0]);
      }

      if (numberA && !numberB) {
        return -1;
      }

      if (!numberA && numberB) {
        return 1;
      }

      // Alphabetical sorting for non-numbered items
      return textA.localeCompare(textB, undefined, {
        sensitivity: "base",
        numeric: true,
      });
    })
    .map((child, index) => (
      <AccordionNode
        key={`${child.tag}-${index}`}
        node={child}
        level={level + 1}
        projectId={projectId}
        projectName={projectName}
        activityLevel={activityLevel}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        openNodes={openNodes}
        setOpenNodes={setOpenNodes}
        onActivityClick={onActivityClick}
        onWbsClick={onWbsClick}
      />
    ))}

          {/* {shouldShowActivities &&
            activities.map((activity, index) => (
            
             <button
  key={`${activity.tag}-${index}`}
  
  
    onClick={(e) => {
  e.stopPropagation();

  
  const item = {
  type: "activity" as const,
  id: Math.abs(activity.tag),
  wbsId: node.tag,
};

setSelectedItem(item);

sessionStorage.setItem(
  "ThirdWBSSelectedItem",
  JSON.stringify(item)
);

  onActivityClick(Math.abs(activity.tag), node.tag);
}}
 
  className={`flex w-full items-center gap-2 rounded-md px-2 py-1 text-left
${
  selectedItem?.type === "activity" &&
  selectedItem.id === Math.abs(activity.tag)
    ? 
    
     "bg-indigo-50"
    : "hover:bg-emerald-50"
}`}
  style={{ paddingLeft: `${(level + 2) * 10}px` }}
  type="button"
>
                
              <span className=" text-[#58736A]">{activity.text}</span>
             
              </button>


            ))} */}
            {shouldShowActivities &&
  activities.map((activity, index) => {
    const activityId = Math.abs(activity.tag);

   return (
  <div
    key={`${activity.tag}-${index}`}
    className={`group flex w-full items-center rounded-md ${
      selectedItem?.type === "activity" &&
      selectedItem.id === activityId
        ? "bg-indigo-50"
        : "hover:bg-emerald-50"
    }`}
  >
    {/* Activity name */}
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();

        const item = {
          type: "activity" as const,
          id: activityId,
          wbsId: node.tag,
        };

        setSelectedItem(item);

        sessionStorage.setItem(
          "ThirdWBSSelectedItem",
          JSON.stringify(item)
        );

        onActivityClick(activityId, node.tag);
      }}
      className="inline-flex items-center gap-2 rounded-md px-2 py-1 text-left"
      style={{ paddingLeft: `${(level + 2) * 10}px` }}
    >
      <span className="text-[#58736A]">
        {activity.text}
      </span>
    </button>

    {/* BOM button beside activity name */}
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();

        const params = new URLSearchParams({
          projectId: String(projectId),
          projectName: projectName || "",
          wbsId: String(node.tag),
          wbsName: node.text,
          activityId: String(activityId),
          activityName: activity.text,
        });

        window.open(
          `/activity-bom?${params.toString()}`,
          "_blank",
          "noopener,noreferrer"
        );
      }}
      className="ml-1 rounded border border-gray-400 bg-white px-1 py-0
                 text-[11px] text-gray-700
                 opacity-0 pointer-events-none
                 group-hover:opacity-100
                 group-hover:pointer-events-auto
                 hover:bg-gray-100
                 transition-all duration-200"
      title="BOM"
    >
      BOM
    </button>
  </div>
);


  })}


        </div>
      )}
    </div>
  );
};

const ThirdWBS = ({ projectId, projectName, activityLevel, onActivityClick, onWbsClick }: Props) => {
  const [tree, setTree] = useState<TreeNode | null>(null);
  const [loading, setLoading] = useState(true);

  const [selectedItem, setSelectedItem] = useState<{
  type: "wbs" | "activity";
  id: number;
    wbsId?: number;
} | null>(null);

const [openNodes, setOpenNodes] = useState<Record<string, boolean>>({
  root: true,
});
  //const [activityLevel, setActivityLevel] = useState(1);

  useEffect(() => {
    setLoading(true);

    ThirdWBSAPI.getTree(projectId, activityLevel)
      .then(setTree)
      .catch(() => alert("Failed to load tree"))
      .finally(() => setLoading(false));
  }, [projectId, activityLevel]);

  useEffect(() => {
  if (!tree) return;

  if (!selectedItem) {
    setSelectedItem({
      type: "wbs",
      id: tree.tag, // root tag = 0
    });
  }
}, [tree, selectedItem]);

  useEffect(() => {
  const savedOpenNodes = sessionStorage.getItem(
    "ThirdWBSOpenNodes"
  );

  if (savedOpenNodes) {
    setOpenNodes(JSON.parse(savedOpenNodes));
  } else {
    setOpenNodes({
      root: true,
    });
  }
}, []);


useEffect(() => {
  const saved = sessionStorage.getItem(
    "ThirdWBSSelectedItem"
  );

  if (!saved) return;

  const item = JSON.parse(saved);

  setSelectedItem(item);

  if (item.type === "wbs") {
    onWbsClick(item.id);
  }

  if (item.type === "activity") {
    onWbsClick(item.wbsId);

    setTimeout(() => {
      onActivityClick(item.id, item.wbsId);
    }, 200);
  }
}, []);

  // if (loading) return <p>Loading...</p>;
  if (loading)
  return (
    <p
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      Loading...
    </p>
  );

  return (
    // <div className="flex h-full flex-col" style={{ backgroundColor: "#eaeafc" }}>
      //  <div className="flex h-full flex-col bg-white"> 
     <div
  className="flex h-full flex-col bg-white"
  style={{ fontFamily: "'Segoe UI', sans-serif" ,
     fontSize: "13px",
    fontWeight: 400,
  }}
>
     {/*  <div className="flex items-center gap-2 px-3 py-1">
       
      </div> */}

      {/* <div className="h-full overflow-y-auto px-2 pt-0 pb-4 thin-scrollbar"> */}
      <div className="h-full overflow-y-auto px-1 pt-0 pb-1 thin-scrollbar">
        {tree ? (
          <AccordionNode
            node={tree}
            projectId={projectId}
            projectName={projectName}
            activityLevel={activityLevel}
             selectedItem={selectedItem}
  setSelectedItem={setSelectedItem}
  openNodes={openNodes}
setOpenNodes={setOpenNodes}
            onActivityClick={onActivityClick}
            onWbsClick={onWbsClick}
          />
        ) : (
          <p className=" text-gray-500">No WBS found</p>
        )}
      </div>
    </div>
  );
};

export default ThirdWBS;